import styled, { css } from 'styled-components';
import { MAP_CELL_MODES } from '../../common/BaseTable/BaseTable.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const Root = styled.div `
  ${({ stickyHeader, mode, maxHeight }) => {
    const { borderColor } = MAP_CELL_MODES[mode];
    return css `
      ${stickyHeader &&
        `
        border-bottom: 1px solid ${borderColor};
        border-top: 1px solid ${borderColor};
        overflow-y: auto;
        max-height: ${maxHeight}px;

        table {
          border-top: 0;
          border-bottom: 0;
        }

        thead {
          position: sticky;
          top: 0;
          z-index: 1;
        }

        table tr {
          border: 0;
        }

        table tbody tr {
          border-bottom: 1px solid ${borderColor};
          border-left: 1px solid ${borderColor};
        }

        table thead tr th {
          border-bottom: 1px solid ${borderColor};
        }
      `}
    `;
}}
`;
export const ControlledTableRoot = styled.table `
  border-collapse: collapse;
`;
export const ControlledTableHeadActions = styled.th `
  ${({ borderType }) => {
    return css `
      ${borderType === 'full' &&
        `
        box-shadow: -2px 2px 5px 0px rgba(38, 26, 25, 0.04), -3px 0px 5px 0px rgba(38, 26, 25, 0.05);
      `}

      ${borderType === 'row' &&
        `
        box-shadow: -2px 2px 5px 0px rgba(38, 26, 25, 0.04), -3px 0px 5px 0px rgba(38, 26, 25, 0.05);
      `}

      ${borderType === 'column' &&
        `
      box-shadow: -3px 0px 0px 0px rgba(38, 26, 25, 0.05);
      `}
    `;
}}
`;
//# sourceMappingURL=ControlledTable.styled.js.map